<template>
  <div class="yh_index">
	  <section class="search_box" style="overflow: hidden;">
	  	<select class="sel_idx" v-model="sel_type">
	    		<option v-for="(x,i) in idx_sel_arr" :value="x.id">{{x.name}}</option>
	    	</select>
	    <p class="center_pos">
	    	
	      <el-input placeholder="请输入关键词" v-model="key_word" class="search search_idx auto_h ">
	        <el-button slot="append" type="primary" class="search_btn" @click="search_fn">搜索</el-button>
	      </el-input>
	    </p>
	  </section>
    <section class="special">
      <div v-show = "article_list.length == 0" style="padding: 0px 0 20px;margin: 30px auto 240px;" class="txt_center">
        <img src="../static/img/no_data.jpg" alt="">
      </div>
      <div class="special_box width1000" v-show = "article_list.length > 0">
        <ul class="article_ul">
          <li class="article_li" v-for = " x in article_list">
            <p class="article_name" v-html="x.name_html" @click="to_details(x)"></p>
            <p class="article_msg">
              <span>{{x.a}}</span>
              <span>{{x.b}}</span>
              <span>{{x.c}}</span>
            </p>
            <p class="article_content" v-html = " x.d"></p>
          </li>
        </ul>
        <el-pagination
          class="right"
          background
          layout="prev, pager, next"
          @current-change="current_page_fn"
          :total="1000">
        </el-pagination>
      </div>
    </section>
  </div>
</template>

<script>
export default { 
  data () {
    return {
    	sel_type: "1",
      key_word: '',
      hot_arr: [
        "京津冀",
        "北京研究",
        "大运河文化"
      ],
      article_list: [],
      current_page: 1,
      idx_sel_arr: [
      	{name:"标题",id:"1"},
      	{name:"作者",id:"2"},
      	{name:"单位",id:"3"},
      	{name:"摘要",id:"4"},
      	{name:"关键词",id:"5"}
      ]
    }
  },
  methods: {
    search_fn() {
    	var obj = {};
    	obj.sel_type = this.sel_type;
    	obj.key_word = this.key_word;
    	obj.page = this.current_page;
    // this.$api.axios_idx_search(obj).then(res => {
    //     this.artical = res.artical;
    //     this.content = fn_toStrings(res.content);
    // })
    this.article_list = require("../../static/json/index.json");
    if(this.key_word == ""){
      this.article_list.forEach(x => {
      	x.name_html = x.name;
      	x.d = x.d;
	    })
    }else{
    	this.article_list.forEach(x => {
	      x.name_html = x.name.split(this.key_word).join("<span style='color: #A8071A' class='article_name_span'>" + this.key_word + "</span>")
	      x.d = x.d.split(this.key_word).join("<span style='color: #A8071A' class='article_content_span'>" + this.key_word + "</span>")
	    })
    }
    
    },
    current_page_fn(val) {
      this.current_page = val;
      
    },
    to_details(x) {
      this.$router.replace({path:'/details', query: x});
    },
    to_hot_Fn() {
      this.$router.replace("/hot")
    }
  },
  mounted() {
    this.key_word = this.$route.query.key_word;
    this.sel_type = this.$route.query.sel_type;
    this.search_fn();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("../assets/css/else");
@import url("../assets/css/index_result");
.center_pos{
  width: 660px;
  margin: -30px auto 0;
  height: 100%;
}
.sel_idx{
	display: block;
	
	position: relative;
	left: 110px;
	top: 63px;
	width: 100px;
	height: 30px;
	background: #FFFFFF;
	border: 0;
	z-index: 9;
	border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/Index_result.vue